// VAPID public key for Web Push (D2). Paired with the `vapid-private-key`
// stored in dev SSM (and the matching VAPID_PRIVATE_KEY in .env for local
// runs). To rotate, run `scripts/infra/generate-vapid-keys.sh`, paste the
// new private key into SSM via `setup-ssm-parameters.sh -e <env> --rotate`,
// and replace this constant with the matching public key. Existing browser
// subscriptions become invalid on rotation and must re-subscribe.
export const VAPID_PUBLIC_KEY = "BEr26DXffxmZ9gQm2U87ojiXm8OM1Okg8JDFIaGsQZsnWMjd7PT8FvQzCGDdw6gsQDkICF-xtDAgwg2vnDHye4w";
